// The three clocks.
//
// Her location is chosen further down the page than this strip sits, and for an
// already-booked date night the server has the instant but not the city — so
// before she has told us, both of her cities are shown alongside his.
//
// The browser could be asked (`Intl…resolvedOptions().timeZone`) and would
// usually be right. It is not asked, for two reasons: the flow is specified not
// to infer her location, and it would be wrong in exactly the cases that matter
// — an airport, a VPN, a phone that has not caught up after a flight. She flies
// between these two cities, so that is not hypothetical. Showing both costs one
// line of text and is never wrong.

import { Temporal } from 'temporal-polyfill';
import { HOME_ZONE, LOCATIONS } from '../shared/zones.js';

const pad = (n) => String(n).padStart(2, '0');

/** @returns {{key: string, label: string, time: string, mine: boolean}[]} */
export function readClocks(locationId = null, nowInstant = new Date().toISOString()) {
  const at = Temporal.Instant.from(nowInstant);
  const face = (key, label, zone, mine) => {
    const z = at.toZonedDateTimeISO(zone);
    const h12 = z.hour % 12 === 0 ? 12 : z.hour % 12;
    return {
      key,
      label,
      time: `${h12}:${pad(z.minute)}`,
      meridiem: z.hour < 12 ? 'am' : 'pm',
      mine,
    };
  };

  const hers = LOCATIONS.map((l) => face(l.id, l.label, l.zone, l.id === locationId));
  // Once she has said where she is, the other city is no longer interesting.
  const shown = locationId ? hers.filter((f) => f.mine) : hers;
  return [...shown, face('home', 'me', HOME_ZONE, false)];
}
